module.exports = __webpack_public_path__ + "img/part9-2.bbf07d53.png";